import IconBox from '../../components/common/icon-box'
import MainNav from '../../components/homepage/main-nav'
import Layout from '../../components/layout/layout'
import { ConfirmAddressDto } from '@ringo/shared'
import { useUser } from '../../common/hooks/auth/useUser'
import { useMutation } from '@tanstack/react-query'
import InfoMessage from '../../components/common/info-message'
import { useTranslation } from '../../useTranslation'
import Button from '../../components/common/button'
import { Link } from 'react-router-dom'
import { useAddressApi } from '../../common/api-context'

const ConfirmAddress = () => {
    const { extractTokenFromUrl, refreshUserData } = useUser()

    const { t } = useTranslation()
    const addressApi = useAddressApi()

    const confirmAddress = useMutation({
        mutationFn: () => {
            const confirmAddressData: ConfirmAddressDto = {
                token: extractTokenFromUrl() as string,
            }
            return addressApi.confirmAddress(confirmAddressData)
        },
        onSuccess: () => {
            refreshUserData()
        },
    })

    return (
        <Layout>
            <MainNav />
            <div className="mx-auto my-16 w-3/6 max-tablet:w-2/3">
                <IconBox icon="address-card">
                    <div className="py-10 px-2">
                        {!confirmAddress.isSuccess && !confirmAddress.isError && (
                            <>
                                <h1 className="font-bold text-xl text-left leading-0 max-tablet:text-base">{t('login.confirmAddressCreation')}</h1>
                                <div className="flex justify-center mt-7 gap-3">
                                    <Button type={'squareYellow'} text={t('no')} className="w-[100px] text-center" />
                                    <Button type={'squareBlue'} text={t('yes')} onClick={() => confirmAddress.mutate()} className="w-[100px] text-center" />
                                </div>
                            </>
                        )}
                        {confirmAddress.isSuccess && <InfoMessage type="success" label={t('login.addressConfirmSuccess')} icon="check" />}
                        {confirmAddress.isError && <InfoMessage type="error" label={t('login.addressConfirmError')} icon="xmark" />}
                        {(confirmAddress.isSuccess || confirmAddress.isError) && (
                            <div className="text-center -mb-4">
                                <Link to="/">
                                    <Button text={t('backToRingo')} type={'squareBlue'} />
                                </Link>
                            </div>
                        )}
                    </div>
                </IconBox>
            </div>
        </Layout>
    )
}

export default ConfirmAddress
